import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider, useDispatch } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import ModalSlice from './Slices/ModalSlice';
import PublicCollectionsDataSlice from './Slices/PublicCollectionsDataSlice';
import UserActions from './Slices/UserActions'
import { ConfigProvider, theme } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import { createRoot } from 'react-dom/client';
import AuthorCollections from './Slices/AuthorCollectionsSlice';
import AuthorDetails from './Slices/AuthorDetailsSlice';
import PublicPageDataSlice from './Slices/PublicPageDataSlice';
import WindowNHQSlice from './Slices/WindowNHQSlice';

export const useAppDispatch = () => useDispatch<typeof store.dispatch>()

export const store = configureStore({
  
  reducer: {
    modalData : ModalSlice,
    publicCollectionsData : PublicCollectionsDataSlice,
    userActions : UserActions,
    authorCollections : AuthorCollections,
    authorDetails :AuthorDetails,
    publicPageData : PublicPageDataSlice,
    windowNHQ : WindowNHQSlice,
  },
})

const hostElement = document.createElement('div');
hostElement.id = 'notablehq-content-root-public';
hostElement.className = 'notablehq-widget-public';
document?.querySelector('#root')?.appendChild(hostElement);

const shadowRoot = hostElement.attachShadow({ mode: 'open' });
const container = document.createElement('div');
container.id = 'notablehq-root-public';
shadowRoot.appendChild(container);
const root = createRoot(container);


root.render(
  <StyleProvider container={shadowRoot}>
  <ConfigProvider  getPopupContainer={() => container} theme={{algorithm: theme.defaultAlgorithm,
  components: {
    Popover: {
      titleMinWidth: 50,
    },
  },}}>
  <Provider store={store}>
  <App />
</Provider>
</ConfigProvider>
</StyleProvider>
);

reportWebVitals();